import React, { useEffect, useState } from "react";
import { io } from "socket.io-client";

export const Test = () => {
  const [messages, setMessages] = useState([]);

  useEffect(() => {
    const socket = io("http://localhost:9091", {
      transports: ["websocket"],
    });
    socket.on("connect", () => {
      console.log("Connected to WebSocket server");
    });

    socket.on("response", (message) => {
      console.log("Received response:", message);
    });

    socket.on("message", (message) => {
      console.log("Received message:", message);
      setMessages((prevMessages) => [...prevMessages, message]);
    });
    return () => {
      socket.off("connect");
      socket.off("message");
      socket.disconnect();
    };
  }, []);

  return (
    <div>
      <h1>WebSocket Test</h1>
      <ul>
        {messages.map((msg, index) => (
          <li key={index}>{msg}</li>
        ))}
      </ul>
    </div>
  );
};

export default Test;
